import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import zxcvbn from 'zxcvbn';
import { getClass } from '../../../utils/component-helpers';

import Strength from './strength';
import LoginNav from './new-login-nav';

import { authService } from '../../../services/auth';

import './reset-password.scss';

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.AuthService = authService;

    this.token = new URLSearchParams(this.props.location.search).get('token');
    this.newUser = props.location.state && props.location.state.newUser;
    this.userCredentials = props.location.state && props.location.state.credentials;

    this.state = {
      credentials: {
        newPassword: '',
        confirmedPassword: '',
      },
      messages: {
        newPassword: '',
        confirmedPassword: '',
      },
      passwordReset: false,
      showInfoType: '',
      passwordStrength: 0,
    };
  }

  updateField(name) {
    return event => {
      const { value } = event.target;
      const currentCredentials = cloneDeep(this.state.credentials);

      currentCredentials[name] = value;
      this.setState({
        credentials: currentCredentials,
        showInfoType: 'meter',
        passwordStrength:
          name === 'newPassword' ? zxcvbn(value).score : this.state.passwordStrength,
      });
    };
  }

  updateWarningMessage(message, type) {
    const otherType = type === 'newPassword' ? 'confirmedPassword' : 'newPassword';
    const messages = cloneDeep(this.state.messages);
    messages[type] = message;
    messages[otherType] = '';
    this.setState({
      messages,
      showInfoType: 'warning',
    });
  }

  resetPassword(event) {
    event.preventDefault();

    const { newPassword } = this.state.credentials;
    const { confirmedPassword } = this.state.credentials;

    if (!newPassword) {
      this.updateWarningMessage('Please enter a new password.', 'newPassword');
      return;
    }

    if (!confirmedPassword) {
      this.updateWarningMessage('Please enter the new password to confirm.', 'confirmedPassword');
      return;
    }

    if (newPassword !== confirmedPassword) {
      this.updateWarningMessage('Your new password does not match.', 'confirmedPassword');
      return;
    }

    if (this.state.passwordStrength < 1 || newPassword.length < 8) {
      return;
    }

    if (this.newUser) {
      return this.changePassword();
    }
    if (!this.token) {
      this.updateWarningMessage(
        'Reset token not found, please restart password reset process.',
        'newPassword',
      );
      return;
    }

    return this.AuthService.completeResetPassword(this.token, newPassword)
      .then(() => {
        this.updateWarningMessage('', 'newPassword');
        this.setState({
          passwordReset: true,
        });
      })
      .catch(() => {
        this.updateWarningMessage('Unable to reset password.', 'newPassword');
      });
  }

  changePassword() {
    const credentials = {
      ...this.userCredentials,
      new_password: this.state.credentials.newPassword,
      repeat_new_password: this.state.credentials.confirmedPassword,
    };
    this.AuthService.changePassword(credentials).then(() => {
      this.updateWarningMessage('', 'newPassword');
      this.setState({ passwordReset: true });
    });
  }

  render() {
    const password = this.state.credentials.newPassword;
    const passwordScore = zxcvbn(password).score;
    const showMeter = this.state.showInfoType === 'meter';

    const resetPasswordText = this.newUser
      ? "welcome. let's get you set up."
      : 'Please fill in your new password below and click save password.';
    const submitButtonText = this.newUser ? 'SET NEW PASSWORD' : 'SAVE PASSWORD';
    const contentHeaderText = this.newUser ? 'New account' : 'New password';
    const confirmText = this.newUser
      ? 'your new password has been set up'
      : 'your password has been reset';

    const passwordStrength = <Strength score={password.length < 8 ? 'short' : passwordScore} />;

    const newPasswordWarning = (
      <p className={`warning ${this.state.messages.newPassword ? '' : 'disabled'}`}>
        {this.state.messages.newPassword}
      </p>
    );

    const confirmedPasswordWarning = (
      <p className={`warning ${this.state.messages.confirmedPassword ? '' : 'disabled'}`}>
        {this.state.messages.confirmedPassword}
      </p>
    );

    const passwordContent = this.state.passwordReset ? (
      <div className="reset-confirmation">
        <h1 className="reset-text">{confirmText}</h1>
        <div className="buttons">
          <a className="sign-in-btn" href="/v2/login">
            <span>CLICK HERE</span> TO SIGN IN
          </a>
        </div>
      </div>
    ) : (
      <div className="main-content">
        <div className="instruction-text">
          <p className="reset-password">{resetPasswordText}</p>
        </div>
        <form onSubmit={this.resetPassword.bind(this)} className="reset-password-form">
          <div className="input-containers">
            <div className="input-container new-password">
              <label className="input-label">New password</label>
              <input
                className="newPassword"
                label="New Password"
                type="password"
                onChange={this.updateField('newPassword')}
              />
              {showMeter ? passwordStrength : newPasswordWarning}
            </div>
            <div className="input-container confirm-password">
              <label className="input-label">Confirm new password</label>
              <input
                className="confirmedPassword"
                label="Confirm new password"
                type="password"
                onChange={this.updateField('confirmedPassword')}
              />
              {confirmedPasswordWarning}
            </div>
          </div>
          <div className="buttons">
            <button className="submit-btn">{submitButtonText}</button>
          </div>
        </form>
      </div>
    );

    return (
      <div
        className={getClass('reset-password', {
          mobile: this.props.isMobile,
          'new-user': this.newUser,
        })}
      >
        <LoginNav isMobile={this.props.isMobile} />
        <div className="content">
          <div className="content-header">
            <span className="text">{contentHeaderText}</span>
            <span className="line"></span>
          </div>
          {passwordContent}
        </div>
      </div>
    );
  }
}

export default withRouter(ResetPassword);
